
import {
  defineComponent, inject, reactive, watch, Ref, provide, ref,
  onMounted,
  onUnmounted,
  computed,
  nextTick,
} from 'vue';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/Icone.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { useRequisicaoAutorizacaoBase } from '@/composables/MeuSistema/RequisicaoAutorizacaoBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { ETipoFrete } from '@/models/Enumeradores/Compartilhados/ETipoFrete';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { IEtapaProcessoVendas } from '@/models/Entidades/Cadastros/Vendas/IProcessoVendas';
import ServicoVendas from '@/servicos/Vendas/ServicoVendas';
import { ETipoRelacaoPessoa } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoRelacaoPessoa';
import {
  IVenda, IVendaItem,
  IVendaNotaFiscalServico,
} from '@/models/Entidades/Vendas/IVenda';
import {
  INotaFiscal, INotaFiscalAnexo, INotaFiscalDestinatario, INotaFiscalDetalhePagamento, INotaFiscalEmitente, INotaFiscalImpostoTotal, INotaFiscalIncidenciaCalculo, INotaFiscalItem, INotaFiscalItemCombustivel, INotaFiscalItemEstoque, INotaFiscalItemImposto, INotaFiscalItemImpostoCofins, INotaFiscalItemImpostoIcms, INotaFiscalItemImpostoImportacao, INotaFiscalItemImpostoIpi, INotaFiscalItemImpostoPis, INotaFiscalItemImpostoSubstituicaoTributaria, INotaFiscalItemImpostoIbsCbs, INotaFiscalItemMedicamento, INotaFiscalTransporte, INotaFiscalTransporteVolume,
} from '@/models/Entidades/Fiscal/INotaFiscal';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import storeSistema from '@/store/storeSistema';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';
import { ETipoValorMovimentacao } from '@/models/Enumeradores/ETipoValorMovimentacao';
import ServicoCalculosComerciais from '@/servicos/ServicoCalculosComerciais';
import { EOrigemValorItem } from '@/models/Enumeradores/EOrigemValorItem';
import { ETipoMovimentoComercial } from '@/core/models/Enumeradores/ETipoMovimentoComercial';
import ServicoFormaPagamento from '@/servicos/Cadastros/Financeiro/ServicoFormaPagamento';
import { IFormaPagamento } from '@/models/Entidades/Cadastros/Financeiro/IFormaPagamento';
import { ETipoOperacao } from '@/models/Enumeradores/Fiscal/ETipoOperacao';
import { ETipoEmissao } from '@/models/Enumeradores/Fiscal/ETipoEmissao';
import { IDTONotaFiscalRegistroAtividade } from '@/models/DTO/Fiscal/NotasFiscais/IDTONotaFiscalRegistroAtividade';
import { useFocusBase } from '@/core/composables/FocusBase';
import ServicoPessoa from '@/servicos/Cadastros/Pessoas/ServicoPessoa';
import { IDTOPessoaMovimento } from '@/models/DTO/Cadastros/Pessoas/IDTOPessoaMovimento';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import UtilitarioMatematico from '@/core/utilitarios/UtilitarioMatematico';
import ServicoEmpresa from '@/servicos/MeuSistema/ServicoEmpresa';
import { ETipoPessoa } from '@/models/Enumeradores/Compartilhados/ETipoPessoa';
import { ETipoBloqueioCliente } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoBloqueioCliente';
import ServicoCliente from '@/servicos/Cadastros/Pessoas/ServicoCliente';
import { ITipoOperacao } from '@/models/Entidades/Cadastros/ITipoOperacao';
import ServicoTipoOperacao from '@/servicos/Cadastros/ServicoTipoOperacao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { EStatusNotaFiscal } from '@/models/Enumeradores/Compartilhados/EStatusNotaFiscal';
import { IParametrosConsultaDefinicaoMovimentacao } from '@/models/ParametrosRequisicao/Cadastros/Tributacoes/IParametrosConsultaDefinicaoMovimentacao';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';
import SelecionarProdutoFrenteCaixa from '@/components/Cadastros/Produtos/SelecionarProdutoFrenteCaixa.vue';
import { IDTOTabelaPrecoItemProduto } from '@/models/DTO/Cadastros/Precificacao/IDTOTabelaPrecoItemProduto';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';
import { ETipoLancamentoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoLancamentoRastreabilidade';
import { IEstoque } from '@/models/Entidades/Cadastros/Estoques/IEstoque';
import FrenteCaixaDetalhePagamento from '@/components/Vendas/Vendas/ModalVenda/PagamentoVenda/FrenteCaixaDetalhePagamento.vue';
import { IDTODadosFrenteCaixa } from '@/models/DTO/Vendas/IDTODadosFrenteCaixa';
import { IAberturaCaixa } from '@/models/Entidades/Financeiro/ControleCaixas/AberturaCaixa';
import SelecionarClienteModal from '@/components/Vendas/Vendas/ModalVenda/PagamentoVenda/SelecionarClienteModal.vue';
import ServicoUtilitario from '@/servicos/MeuSistema/ServicoUtilitario';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import SelecionarAberturaCaixaModal from '@/views/Financeiro/ControleCaixas/SelecionarAberturaCaixaModal.vue';
import FechamentoCaixaModal from '@/views/Financeiro/ControleCaixas/FechamentoCaixaModal.vue';
import { ICaixa } from '@/models/Entidades/Cadastros/Financeiro/ICaixa';
import ServicoCaixa from '@/servicos/Cadastros/Financeiro/ServicoCaixa';
import ServicoControleCaixas from '@/servicos/Financeiro/ServicoControleCaixas';
import { EStatusAberturaCaixa } from '@/models/Enumeradores/Financeiro/EStatusAberturaCaixa';
import ServicoColaborador from '@/servicos/Cadastros/Pessoas/ServicoColaborador';
import FrenteCaixaDescontoModal from '@/components/Vendas/Vendas/FrenteCaixaDescontoModal.vue';

export default defineComponent({
  name: 'FrenteCaixaModal',
  props: {
    visivel: {
      type: Boolean,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
    codigoVenda: {
      type: Number,
      default: 0,
    },
    dadosPadraoFrenteCaixa: {
      type: Object as () => IDTODadosFrenteCaixa,
      required: true,
    },
    aberturaCaixa: {
      type: Object as () => IAberturaCaixa,
      required: true,
    },
  },
  components: {
    Icone,
    SelecionarProdutoFrenteCaixa,
    FrenteCaixaDetalhePagamento,
    SelecionarClienteModal,
    PreviewPdf,
    SelecionarAberturaCaixaModal,
    FechamentoCaixaModal,
    FrenteCaixaDescontoModal,
  },
  emits: ['update:visivel', 'confirmacao', 'update:aberturaCaixa'],
  setup(props, { emit }) {
    const servicoVendas = new ServicoVendas();
    const servicoCalculosComerciais = new ServicoCalculosComerciais();
    const servicoFormaPagamento = new ServicoFormaPagamento();
    const servicoEmpresas = new ServicoEmpresa();
    servicoEmpresas.requisicaoSistema();
    servicoFormaPagamento.requisicaoSistema();
    const servicoNotaFiscal = new ServicoNotaFiscal();
    servicoNotaFiscal.requisicaoSistema();
    const servicoSistema = new ServicoSistema();
    const servicoPessoa = new ServicoPessoa();
    servicoPessoa.requisicaoSistema();
    const servicoCliente = new ServicoCliente();
    const servicoTipoOperacao = new ServicoTipoOperacao();
    servicoTipoOperacao.requisicaoSistema();
    const servicoCenarioFiscal = new ServicoCenarioFiscal();
    servicoCenarioFiscal.requisicaoSistema();
    const servicoUtilitario = new ServicoUtilitario();
    const servicoCaixa = new ServicoCaixa();
    const servicoControleCaixas = new ServicoControleCaixas();
    const servicoColaborador = new ServicoColaborador();
    const dataAtual = ref('');
    const horaAtual = ref('');
    const refSelecionarProduto = ref<any>(null);

    const {
      telaBase,
      apresentarMensagemSucesso, apresentarMensagemAlerta, preencherEmpresasDisponiveis, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemErro,
    } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao,
    } = useModalBase(props, emit);

    const {
      focusBase, focusElemento, proximoElemento, elementoAnterior,
    } = useFocusBase();

    focusBase.classElementos = 'ss-venda-dados-principais';

    const { requisicaoAutorizacaoBase } = useRequisicaoAutorizacaoBase();
    const dadosEmpresa = inject('VENDAS_EMPRESA') as Ref<IDTODadosEmpresa>;
    const etapa = inject('VENDAS_ETAPA_LANCAMENTO') as Ref<IEtapaProcessoVendas>;
    const permissaoServico = inject('VENDAS_PERMISSAO_SERVICO') as Ref<boolean>;
    const listaContainer = ref<HTMLElement | null>(null);

    telaBase.identificadorRecurso = 'VENDAS';
    let debounceAtualizacaoTotalizadores = 0;
    let debounceRenderizar = 0;
    const state = reactive({
      venda: {} as IVenda,
      dadosPessoaMovimento: {} as IDTOPessoaMovimento,
      ufEmpresa: '',
      registrosAtividade: [] as IDTONotaFiscalRegistroAtividade[],
      incidenciasCalculo: [] as INotaFiscalIncidenciaCalculo[],
      tipoOperacao: {} as ITipoOperacao,
      cacheRegistro: {} as ISalvamentoAutomatico,
      itens: [] as IVendaItem[],
      itemSelecionado: {} as IVendaItem,
      item: {} as IVendaItem,
      permitirNfe: true,
      permitirNfce: true,
      regimeTributario: 0,
      regimeTributarioEspecial: 0,
      totalCaixaLancado: 0,
      totalCarteiraLancado: 0,
      telaMobile: false,
      editavel: false,
      cacheDisponivel: false,
      calculandoValores: false,
      chaveItens: 0,
      carregando: false,
      carregandoItens: false,
      adicionarPrimeiroItem: false,
      buscarDadosFiscaisRecalcular: false,
      arquivosPdf: [] as IArquivoPdf[],
      valorTotalImpostos: 0,
      statusBloqueioCliente: false,
      liberacaoBloqueioCliente: false,
      tipoInfoBloqueioCliente: 'info',
      editarComissao: false,
      dadosAdicionais: '',
      isFullScreen: false,
      exibirFechamentoVenda: false,
      tiposDocumentos: [] as number[],
      exibirSelecionarCliente: false,
      exibirFechamentoCaixa: false,
      exibirAberturaCaixa: false,
      textoBotao: 'Fechar Caixa',
      caixa: {} as ICaixa,
      estoqueItem: 0,
      abriuPDF: false,
      exibirDesconto: false,
      produtoSelecionado: {} as IVendaItem,
      inserindoDesconto: false,
      valorDesconto: 0,
      indexSelecionado: -1,
      navegandoLista: false,
    });

    const atualizarDataHora = () => {
      const agora = new Date();

      // Data no formato DD/MM/AAAA
      dataAtual.value = agora.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      // Hora no formato HH:mm:ss
      horaAtual.value = agora.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    };

    let intervalo: number;

    function handleFullScreenChange() {
      state.isFullScreen = !!document.fullscreenElement;
      // Force re-render if needed
      state.chaveItens += 1;
    }

    provide('VENDA_INCIDENCIA_CALCULO', state.incidenciasCalculo);

    const computedAberturaCaixa = computed({
      get: () => props.aberturaCaixa,
      set: (val: IAberturaCaixa) => {
        if (val.status === EStatusAberturaCaixa.Fechada) {
          state.textoBotao = 'Abrir Caixa';
        } else {
          state.textoBotao = 'Fechar Caixa';
        }
        emit('update:aberturaCaixa', val);
      },
    });

    function instanciaNovoItem(): IVendaItem {
      const itemVenda = {} as IVendaItem;
      itemVenda.emDigitacao = false;
      itemVenda.dadosPrecoProduto = {} as IDTOTabelaPrecoItemProduto;
      itemVenda.dadosPrecoProduto.codigo = 0;
      itemVenda.dadosPrecoProduto.casasDecimaisTipoPreco = 2;
      itemVenda.percentualFormacaoPreco = 0;
      itemVenda.tipoRastreabilidade = ETipoRastreabilidade.Nenhum;
      itemVenda.tipoLancamentoRastreabilidade = ETipoLancamentoRastreabilidade.Manual;
      itemVenda.itemNotaFiscal = {} as INotaFiscalItem;
      itemVenda.itemNotaFiscal.estoquesDisponiveis = [] as IEstoque[];
      itemVenda.itemNotaFiscal.codigoProdutoDefinicao = 0;
      itemVenda.itemNotaFiscal.codigoUnidadePrincipal = 0;
      itemVenda.itemNotaFiscal.fatorUnidadePrincipal = 1;
      itemVenda.itemNotaFiscal.quantidade = 1;
      itemVenda.itemNotaFiscal.codigoUnidade = 0;
      itemVenda.itemNotaFiscal.fracionarUnidade = false;
      itemVenda.itemNotaFiscal.siglaUnidade = '';
      itemVenda.itemNotaFiscal.fatorConversao = 1;
      itemVenda.itemNotaFiscal.casasDecimaisUnidade = 2;
      itemVenda.codigoTabelaPrecoItemProduto = 0;
      itemVenda.itemNotaFiscal.precoUnitario = 0;
      itemVenda.itemNotaFiscal.casasDecimaisPrecoUnitario = 2;
      itemVenda.itemNotaFiscal.valorDesconto = 0;
      itemVenda.itemNotaFiscal.valorTotal = 0;
      itemVenda.itemNotaFiscal.movimentarEstoque = true;
      itemVenda.itemNotaFiscal.compoeTotal = true;
      itemVenda.itemNotaFiscal.origemFrete = EOrigemValorItem.Rateio;
      itemVenda.itemNotaFiscal.valorFrete = 0;
      itemVenda.itemNotaFiscal.origemOutrasDespesas = EOrigemValorItem.Rateio;
      itemVenda.itemNotaFiscal.origemSeguro = EOrigemValorItem.Rateio;
      itemVenda.itemNotaFiscal.valorSeguro = 0;
      itemVenda.itemNotaFiscal.impostos = {} as INotaFiscalItemImposto;
      itemVenda.itemNotaFiscal.impostos.codigoCfop = 0;
      itemVenda.itemNotaFiscal.impostos.icms = {} as INotaFiscalItemImpostoIcms;
      itemVenda.itemNotaFiscal.impostos.cst = '00';
      itemVenda.itemNotaFiscal.impostos.codigoCenarioFiscal = state.tipoOperacao.codigoCenarioFiscal;
      itemVenda.itemNotaFiscal.impostos.origemMercadoria = 0;
      itemVenda.itemNotaFiscal.impostos.icms.modalidadeBaseCalculoIcms = 3;
      itemVenda.itemNotaFiscal.impostos.icms.valorIcms = 0;
      itemVenda.itemNotaFiscal.impostos.ipi = {} as INotaFiscalItemImpostoIpi;
      itemVenda.itemNotaFiscal.impostos.ipi.cstIpi = '52';
      itemVenda.itemNotaFiscal.impostos.ipi.tipoCalculoIpi = 1;
      itemVenda.itemNotaFiscal.impostos.ipi.codigoEnquadramentoIpi = '999';
      itemVenda.itemNotaFiscal.impostos.ipi.valorIpi = 0;
      itemVenda.itemNotaFiscal.impostos.pis = {} as INotaFiscalItemImpostoPis;
      itemVenda.itemNotaFiscal.impostos.pis.cstPis = '07';
      itemVenda.itemNotaFiscal.impostos.pis.tipoCalculoPis = 1;
      itemVenda.itemNotaFiscal.impostos.pis.valorPis = 0;
      itemVenda.itemNotaFiscal.impostos.cofins = {} as INotaFiscalItemImpostoCofins;
      itemVenda.itemNotaFiscal.impostos.cofins.cstCofins = '07';
      itemVenda.itemNotaFiscal.impostos.cofins.tipoCalculoCofins = 1;
      itemVenda.itemNotaFiscal.impostos.cofins.valorCofins = 0;
      itemVenda.itemNotaFiscal.impostos.st = {} as INotaFiscalItemImpostoSubstituicaoTributaria;
      itemVenda.itemNotaFiscal.impostos.importacao = {} as INotaFiscalItemImpostoImportacao;
      itemVenda.itemNotaFiscal.impostos.ibsCbs = {} as INotaFiscalItemImpostoIbsCbs;
      itemVenda.itemNotaFiscal.impostos.importacao.valorImportacao = 0;
      itemVenda.itemNotaFiscal.impostos.importacao.valorIof = 0;
      itemVenda.itemNotaFiscal.impostos.importacao.despesasAduaneiras = 0;
      itemVenda.itemNotaFiscal.medicamento = {} as INotaFiscalItemMedicamento;
      itemVenda.itemNotaFiscal.combustivel = {} as INotaFiscalItemCombustivel;
      itemVenda.itemNotaFiscal.estoques = [] as INotaFiscalItemEstoque[];
      state.estoqueItem = 0;
      return itemVenda;
    }

    async function obterFormaPagamento() {
      if (UtilitarioGeral.validaCodigo(state.venda.codigoFormaPagamento)) {
        if (state.venda.notaFiscal.detalhesPagamento.length > 0 && UtilitarioGeral.objetoValido(state.venda.formaPagamento)) {
          apresentarMensagemAlerta('Detalhes de pagamentos zerados devido a alteração da forma de pagamento!');
          state.venda.notaFiscal.detalhesPagamento = [] as INotaFiscalDetalhePagamento[];
        }
        state.venda.formaPagamento = await servicoFormaPagamento.obter(state.venda.codigoFormaPagamento);
        state.venda.formaPagamento.tiposDocumentosFinanceiro = await servicoFormaPagamento.obterTiposDocumentos(state.venda.codigoFormaPagamento, state.venda.codigoEmpresa);
        state.venda.formaPagamento.tiposDocumentosFinanceiro.forEach((d) => {
          state.tiposDocumentos.push(d.codigoTipoDocumentoFinanceiro);
        });
        state.venda.formaPagamento.tabelasPreco = await servicoFormaPagamento.obterTabelasPreco(state.venda.codigoFormaPagamento, state.venda.codigoEmpresa);
      } else {
        state.venda.formaPagamento = {} as IFormaPagamento;
      }
    }

    async function preencherTipoOperacao() {
      state.venda.codigoTipoOperacao = props.dadosPadraoFrenteCaixa.codigoTipoOperacao;
      if (state.venda.codigoTipoOperacao > 0) {
        state.tipoOperacao = await servicoTipoOperacao.obter(state.venda.codigoTipoOperacao, state.venda.codigoEmpresa);
        state.venda.codigoFormaPagamento = state.tipoOperacao.codigoFormaPagamento;
        obterFormaPagamento();
      }
    }

    async function verificarPermissaoNFeNFce() {
      if (state.dadosPessoaMovimento.codigoEstado === 0) {
        state.permitirNfce = true;
        state.permitirNfe = false;
        state.venda.notaFiscal.modelo = '65';
        return;
      }

      if (state.dadosPessoaMovimento.uf !== dadosEmpresa.value.uf) {
        state.permitirNfe = true;
        state.permitirNfce = false;
        state.venda.notaFiscal.modelo = '55';
        return;
      }

      if (state.dadosPessoaMovimento.tipoPessoa === ETipoPessoa.Fisica) {
        const cpfsInvalidos = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
        if (cpfsInvalidos.includes(state.dadosPessoaMovimento.cpfCnpj)) {
          state.permitirNfe = false;
          state.permitirNfce = true;
          state.venda.notaFiscal.modelo = '65';
          return;
        }
        const cpfValido = await servicoUtilitario.validarCpfCnpj(state.dadosPessoaMovimento.cpfCnpj);
        if (!cpfValido.sucesso) {
          state.permitirNfe = false;
          state.permitirNfce = true;
          state.venda.notaFiscal.modelo = '65';
          return;
        }
      }

      state.permitirNfe = true;
      state.permitirNfce = true;
      if (!UtilitarioGeral.validaCodigo(props.codigoVenda)) state.venda.notaFiscal.modelo = '65';
    }

    async function atualizarInformacoesPessoa(alterouCliente: boolean) {
      if (!alterouCliente) {
        state.venda.codigoCliente = props.dadosPadraoFrenteCaixa.codigoCliente;
        state.venda.notaFiscal.destinatario.codigoPessoa = props.dadosPadraoFrenteCaixa.codigoPessoa;
      }
      const dados = await servicoPessoa.obterDadosMovimentacao(state.venda.notaFiscal.destinatario.codigoPessoa, state.venda.codigoEmpresa);
      state.venda.notaFiscal.destinatario.cpfCnpj = dados.cpfCnpj;
      state.statusBloqueioCliente = await servicoCliente.obterStatusBloqueioCliente(state.venda.codigoCliente, ETipoBloqueioCliente.Movimentacao, 0);
      state.tipoInfoBloqueioCliente = state.liberacaoBloqueioCliente ? 'info' : 'warning';
      if (dados.cpfCnpj !== state.dadosPessoaMovimento.cpfCnpj && UtilitarioGeral.validaLista(state.venda.notaFiscal.detalhesPagamento) && state.dadosPessoaMovimento.cpfCnpj !== '') {
        apresentarMensagemAlerta('Detalhes de pagamentos zerados devido a alteração do cliente!');
        state.venda.notaFiscal.detalhesPagamento = [] as INotaFiscalDetalhePagamento[];
      }

      state.dadosPessoaMovimento = dados;
      state.buscarDadosFiscaisRecalcular = true;
      verificarPermissaoNFeNFce();
    }

    async function limparTela() {
      state.adicionarPrimeiroItem = false;
      state.buscarDadosFiscaisRecalcular = false;
      state.editarComissao = false;
      state.incidenciasCalculo = servicoVendas.obterIncidenciasNotaFiscalVendaPadrao();
      state.totalCaixaLancado = 0;
      state.totalCarteiraLancado = 0;
      state.venda = {} as IVenda;
      state.venda.codigo = 0;
      state.venda.codigoEmpresa = dadosEmpresa.value.codigoEmpresa;
      state.venda.codigoProcessoVendas = props.dadosPadraoFrenteCaixa.codigoProcessoVenda;
      state.venda.codigoEtapaProcessoVendas = props.dadosPadraoFrenteCaixa.codigoUltimaEtapa;
      state.venda.dataVenda = UtilitarioData.obterDataAtual();
      state.venda.codigoFormaPagamento = 0;
      state.venda.codigoVendedor = 0;
      state.venda.codigoCliente = 0;
      state.venda.codigoContatoCliente = 0;
      state.venda.dataCriacao = UtilitarioData.obterDataAtual();
      state.venda.itens = [] as IVendaItem[];
      state.venda.notaFiscal = {} as INotaFiscal;
      state.venda.notaFiscal.numeroNotaFiscal = 0;
      state.venda.notaFiscal.naturezaOperacao = 'NATUREZA';
      state.venda.notaFiscal.codigoEmpresa = state.venda.codigoEmpresa;
      state.venda.notaFiscal.destinatario = {} as INotaFiscalDestinatario;
      state.venda.notaFiscal.destinatario.codigoPessoa = 0;
      state.venda.notaFiscal.pessoaIdentificada = true;

      state.venda.notaFiscal.tipoOperacao = ETipoOperacao.Saida;
      state.venda.notaFiscal.tipoFrete = ETipoFrete.SemOcorrenciaTransporte;
      state.venda.notaFiscal.tipoEmissao = ETipoEmissao.EmissaoPropria;
      state.venda.notaFiscal.serie = '0';
      state.venda.notaFiscal.dataEmissao = UtilitarioData.obterDataAtual();
      state.venda.notaFiscal.dataEntradaSaida = UtilitarioData.obterDataAtual();
      state.venda.notaFiscal.emitente = {} as INotaFiscalEmitente;
      state.venda.notaFiscal.emitente.codigoPessoa = 0;
      state.venda.notaFiscal.totalImpostos = {} as INotaFiscalImpostoTotal;
      state.venda.notaFiscal.transporte = {} as INotaFiscalTransporte;
      state.venda.notaFiscal.transporte.codigoTransportadora = 0;
      state.venda.notaFiscal.transporte.volumes = [] as INotaFiscalTransporteVolume[];
      state.venda.notaFiscal.totalDesconto = 0;
      state.venda.notaFiscal.totalFrete = 0;
      state.venda.notaFiscal.totalNotaFiscal = 0;
      state.venda.notaFiscal.totalOutrasDespesas = 0;
      state.venda.notaFiscal.totalProdutos = 0;
      state.venda.notaFiscal.totalSeguro = 0;
      state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal = 0;
      state.venda.notaFiscal.anexos = [] as INotaFiscalAnexo[];
      state.venda.notaFiscal.detalhesPagamento = [] as INotaFiscalDetalhePagamento[];
      state.venda.formaPagamento = {} as IFormaPagamento;
      state.dadosPessoaMovimento = {} as IDTOPessoaMovimento;
      state.dadosPessoaMovimento.cpfCnpj = '';
      state.venda.atualizarValores = false;
      state.venda.totalServicos = 0;
      state.registrosAtividade = [] as IDTONotaFiscalRegistroAtividade[];
      state.venda.status = 5;
      state.editavel = props.editavel;
      state.cacheDisponivel = false;
      state.cacheRegistro = {} as ISalvamentoAutomatico;
      state.cacheRegistro.codigo = 0;
      state.carregando = false;
      state.carregandoItens = false;
      state.statusBloqueioCliente = false;
      state.exibirFechamentoVenda = false;
      state.venda.notaFiscal.modelo = '65';
      state.venda.servicos = [] as IVendaNotaFiscalServico[];
      state.venda.aberturaCaixa = computedAberturaCaixa.value;

      state.itemSelecionado = instanciaNovoItem();
      state.item = instanciaNovoItem();
      state.produtoSelecionado = {} as IVendaItem;
      state.indexSelecionado = -1;
    }

    async function novaVenda() {
      await limparTela();
      await preencherTipoOperacao();
      await atualizarInformacoesPessoa(false);
    }

    async function realizarNovaVenda() {
      Modal.confirm({
        title: 'Deseja lançar uma nova venda ?',
        content: 'Os dados da venda atual serão perdidos.',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: 'ok',
        onOk: async () => {
          novaVenda();
        },
      });
    }

    async function obterDadosFiscaisProduto() {
      if (UtilitarioGeral.validaCodigo(state.itemSelecionado.itemNotaFiscal.codigoProdutoDefinicao)) {
        state.carregando = true;

        if (!UtilitarioGeral.valorValido(state.dadosAdicionais)) {
          state.dadosAdicionais = '';
        }

        const parametrosConsultaDefinicaoMovimentacao: IParametrosConsultaDefinicaoMovimentacao = {} as IParametrosConsultaDefinicaoMovimentacao;
        parametrosConsultaDefinicaoMovimentacao.tipoMovimentoComercial = ETipoMovimentoComercial.Vendas;
        parametrosConsultaDefinicaoMovimentacao.codigoEmpresa = dadosEmpresa.value.codigoEmpresa;
        parametrosConsultaDefinicaoMovimentacao.codigoEstado = state.dadosPessoaMovimento.codigoEstado;
        parametrosConsultaDefinicaoMovimentacao.tipoAtividade = state.dadosPessoaMovimento.tipoAtividade;
        parametrosConsultaDefinicaoMovimentacao.tipoIe = state.dadosPessoaMovimento.tipoIe;
        parametrosConsultaDefinicaoMovimentacao.codigoProdutoDefinicao = state.itemSelecionado.itemNotaFiscal.codigoProdutoDefinicao;
        parametrosConsultaDefinicaoMovimentacao.codigoNcm = state.itemSelecionado.itemNotaFiscal.impostos.codigoNcm;
        parametrosConsultaDefinicaoMovimentacao.origemMercadoria = state.itemSelecionado.itemNotaFiscal.impostos.origemMercadoria;
        parametrosConsultaDefinicaoMovimentacao.codigoCenarioFiscal = state.tipoOperacao.codigoCenarioFiscal;
        const definicoesTributarias = await servicoCenarioFiscal.obterDefinicoesMovimentacao(parametrosConsultaDefinicaoMovimentacao);
        if (definicoesTributarias.sucesso) {
          state.itemSelecionado.itemNotaFiscal.impostos.codigoCenarioFiscal = definicoesTributarias.codigoCenarioFiscal;
          if (definicoesTributarias.encontrouDefinicoesIcms) {
            state.itemSelecionado.itemNotaFiscal.impostos.codigoCfop = definicoesTributarias.icms.codigoCfop;
            state.itemSelecionado.itemNotaFiscal.impostos.cfop = definicoesTributarias.icms.cfop;
            if (UtilitarioGeral.valorValido(definicoesTributarias.icms.cstIcms)) {
              state.itemSelecionado.itemNotaFiscal.impostos.cst = definicoesTributarias.icms.cstIcms;
              state.itemSelecionado.itemNotaFiscal.impostos.cson = '';
            } else {
              state.itemSelecionado.itemNotaFiscal.impostos.cson = definicoesTributarias.icms.cson;
              state.itemSelecionado.itemNotaFiscal.impostos.cst = '';
            }
            state.itemSelecionado.itemNotaFiscal.impostos.icms.modalidadeBaseCalculoIcms = definicoesTributarias.icms.modalidadeBaseCalculoIcms;
            state.itemSelecionado.itemNotaFiscal.impostos.icms.aliquotaIcms = definicoesTributarias.icms.aliquotaIcms;
            state.itemSelecionado.itemNotaFiscal.impostos.icms.reducaoBaseCalculoIcms = definicoesTributarias.icms.reducaoBaseCalculoIcms;
            state.itemSelecionado.itemNotaFiscal.impostos.icms.aliquotaFcp = definicoesTributarias.icms.aliquotaFcp;
            state.itemSelecionado.itemNotaFiscal.impostos.icms.calcularIcmsInterestadual = definicoesTributarias.icms.calcularIcmsInterestadual;

            if (UtilitarioGeral.valorValido(definicoesTributarias.icms.informacaoComplementar)) {
              if (UtilitarioGeral.valorValido(state.dadosAdicionais)) {
                if (!state.dadosAdicionais.includes(definicoesTributarias.icms.informacaoComplementar)) {
                  state.dadosAdicionais += definicoesTributarias.icms.informacaoComplementar;
                }
              } else {
                state.dadosAdicionais += definicoesTributarias.icms.informacaoComplementar;
              }
            }
          }

          if (definicoesTributarias.encontrouDefinicoesSubstituicaoTributaria) {
            state.itemSelecionado.itemNotaFiscal.impostos.st.modalidadeBaseCalculoSubstituicao = definicoesTributarias.icms.substituicao.modalidadeBaseCalculoIcmsSubstituicao;
            state.itemSelecionado.itemNotaFiscal.impostos.st.aliquotaSubstituicaoTributaria = definicoesTributarias.icms.substituicao.aliquotaIcmsSubstituicao;
            state.itemSelecionado.itemNotaFiscal.impostos.st.aliquotaIcmsInterno = definicoesTributarias.icms.substituicao.aliquotaIcmsInterno;
            state.itemSelecionado.itemNotaFiscal.impostos.st.margemValorAdicionado = definicoesTributarias.icms.substituicao.margemValorAdicionado;
            state.itemSelecionado.itemNotaFiscal.impostos.st.pautaIcmsSubstituicao = definicoesTributarias.icms.substituicao.pautaIcmsSubstituicao;
            state.itemSelecionado.itemNotaFiscal.impostos.st.reducaoBaseCalculoSubstituicao = definicoesTributarias.icms.substituicao.reducaoBaseCalculoIcmsSubstituicao;
          }

          if (definicoesTributarias.encontrouDefinicoesIpi) {
            state.itemSelecionado.itemNotaFiscal.impostos.ipi.cstIpi = definicoesTributarias.ipi.cstIpi;
            state.itemSelecionado.itemNotaFiscal.impostos.ipi.tipoCalculoIpi = definicoesTributarias.ipi.tipoCalculoIpi;
            state.itemSelecionado.itemNotaFiscal.impostos.ipi.aliquotaIpi = definicoesTributarias.ipi.aliquotaIpi;
            state.itemSelecionado.itemNotaFiscal.impostos.ipi.codigoEnquadramentoIpi = definicoesTributarias.ipi.codigoEnquadramentoIpi;
            if (UtilitarioGeral.valorValido(definicoesTributarias.ipi.informacaoComplementar)) {
              if (UtilitarioGeral.valorValido(state.dadosAdicionais)) {
                if (!state.dadosAdicionais.includes(definicoesTributarias.ipi.informacaoComplementar)) {
                  state.dadosAdicionais += definicoesTributarias.ipi.informacaoComplementar;
                }
              } else {
                state.dadosAdicionais += definicoesTributarias.ipi.informacaoComplementar;
              }
            }
          }

          if (definicoesTributarias.encontrouDefinicoesPis) {
            state.itemSelecionado.itemNotaFiscal.impostos.pis.cstPis = definicoesTributarias.pis.cstPis;
            state.itemSelecionado.itemNotaFiscal.impostos.pis.tipoCalculoPis = definicoesTributarias.pis.tipoCalculoPis;
            state.itemSelecionado.itemNotaFiscal.impostos.pis.aliquotaPis = definicoesTributarias.pis.aliquotaPis;
            state.itemSelecionado.itemNotaFiscal.impostos.pis.reducaoBaseCalculoPis = definicoesTributarias.pis.reducaoBaseCalculoPis;

            if (UtilitarioGeral.valorValido(definicoesTributarias.pis.informacaoComplementar)) {
              if (UtilitarioGeral.valorValido(state.dadosAdicionais)) {
                if (!state.dadosAdicionais.includes(definicoesTributarias.pis.informacaoComplementar)) {
                  state.dadosAdicionais += definicoesTributarias.pis.informacaoComplementar;
                }
              } else {
                state.dadosAdicionais += definicoesTributarias.pis.informacaoComplementar;
              }
            }
          }

          if (definicoesTributarias.encontrouDefinicoesCofins) {
            state.itemSelecionado.itemNotaFiscal.impostos.cofins.cstCofins = definicoesTributarias.cofins.cstCofins;
            state.itemSelecionado.itemNotaFiscal.impostos.cofins.tipoCalculoCofins = definicoesTributarias.cofins.tipoCalculoCofins;
            state.itemSelecionado.itemNotaFiscal.impostos.cofins.aliquotaCofins = definicoesTributarias.cofins.aliquotaCofins;
            state.itemSelecionado.itemNotaFiscal.impostos.cofins.reducaoBaseCalculoCofins = definicoesTributarias.cofins.reducaoBaseCalculoCofins;

            if (UtilitarioGeral.valorValido(definicoesTributarias.cofins.informacaoComplementar)) {
              if (UtilitarioGeral.valorValido(state.dadosAdicionais)) {
                if (!state.dadosAdicionais.includes(definicoesTributarias.cofins.informacaoComplementar)) {
                  state.dadosAdicionais += definicoesTributarias.cofins.informacaoComplementar;
                }
              } else {
                state.dadosAdicionais += definicoesTributarias.cofins.informacaoComplementar;
              }
            }
          }
        }
        state.carregando = false;
      }
    }

    async function atualizarValoresTotais() {
      if (!telaBase.carregando && !state.carregandoItens) {
        clearTimeout(debounceAtualizacaoTotalizadores);
        debounceAtualizacaoTotalizadores = setTimeout(async () => {
          state.venda.notaFiscal.totalProdutos = 0;
          state.venda.notaFiscal.totalDesconto = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoIcmsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIcmsTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoIcmsSubstituicaoTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoIpiTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorIpiTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoPisTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorPisTotal = 0;
          state.venda.notaFiscal.totalImpostos.baseCalculoCofinsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorCofinsTotal = 0;
          state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal = 0;
          state.valorTotalImpostos = 0;

          for (let index = 0; index < state.venda.itens.length; index += 1) {
            if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
              state.venda.itens[index].itemNotaFiscal.valorTotal = servicoCalculosComerciais.calculaValorTotal(state.venda.itens[index].itemNotaFiscal.quantidade, state.venda.itens[index].itemNotaFiscal.precoUnitario, state.venda.itens[index].itemNotaFiscal.valorDesconto, 0);
              if (state.venda.itens[index].itemNotaFiscal.compoeTotal) {
                state.venda.notaFiscal.totalProdutos += state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario;
                state.venda.notaFiscal.totalDesconto += state.venda.itens[index].itemNotaFiscal.valorDesconto;
              }
            }
          }

          state.venda.notaFiscal.totalNotaFiscal = state.venda.notaFiscal.totalProdutos;
          for (let index = 0; index < state.venda.itens.length; index += 1) {
            if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
              const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));

              if (parseFloat((subTotalProduto).toFixed(2)) < parseFloat(((state.venda.itens[index].itemNotaFiscal.valorDesconto)).toFixed(2))) {
                state.venda.itens[index].itemNotaFiscal.valorDesconto = 0;
              }

              if (state.venda.itens[index].itemNotaFiscal.origemFrete === EOrigemValorItem.Rateio) {
                if (state.venda.notaFiscal.totalFrete > 0) {
                  state.venda.itens[index].itemNotaFiscal.valorFrete = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalFrete);
                } else {
                  state.venda.itens[index].itemNotaFiscal.valorFrete = 0;
                }
              }

              if (state.venda.itens[index].itemNotaFiscal.origemOutrasDespesas === EOrigemValorItem.Rateio) {
                if (state.venda.notaFiscal.totalOutrasDespesas > 0) {
                  state.venda.itens[index].itemNotaFiscal.outrasDespesas = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalOutrasDespesas);
                } else {
                  state.venda.itens[index].itemNotaFiscal.outrasDespesas = 0;
                }
              }

              if (state.venda.itens[index].itemNotaFiscal.origemSeguro === EOrigemValorItem.Rateio) {
                if (state.venda.notaFiscal.totalSeguro > 0) {
                  state.venda.itens[index].itemNotaFiscal.valorSeguro = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalSeguro);
                } else {
                  state.venda.itens[index].itemNotaFiscal.valorSeguro = 0;
                }
              }
              state.venda.itens[index].itemNotaFiscal.impostos.icms.aliquotaSimplesNacional = dadosEmpresa.value.aliquotaSimplesNacional;
              const retornoCalculoTributacoes = await servicoCalculosComerciais.calcularTributacoes(state.venda.itens[index].itemNotaFiscal, state.incidenciasCalculo, dadosEmpresa.value.uf);
              if (UtilitarioGeral.objetoValido(retornoCalculoTributacoes)) {
                state.venda.itens[index].itemNotaFiscal.impostos.icms.baseCalculoIcms = retornoCalculoTributacoes.icms.baseCalculoIcms;
                state.venda.itens[index].itemNotaFiscal.impostos.icms.valorIcms = retornoCalculoTributacoes.icms.valorIcms;
                state.venda.itens[index].itemNotaFiscal.impostos.icms.valorSimplesNacional = retornoCalculoTributacoes.icms.valorSimplesNacional;

                state.venda.notaFiscal.totalImpostos.baseCalculoIcmsTotal += state.venda.itens[index].itemNotaFiscal.impostos.icms.baseCalculoIcms;
                state.venda.notaFiscal.totalImpostos.valorIcmsTotal += state.venda.itens[index].itemNotaFiscal.impostos.icms.valorIcms;

                state.venda.itens[index].itemNotaFiscal.impostos.st.baseCalculoSubstituicaoTributaria = retornoCalculoTributacoes.icms.baseCalculoSubstituicaoTributaria;
                state.venda.itens[index].itemNotaFiscal.impostos.st.valorSubstituicaoTributaria = retornoCalculoTributacoes.icms.valorSubstituicaoTributaria;

                state.venda.notaFiscal.totalImpostos.baseCalculoIcmsSubstituicaoTotal += state.venda.itens[index].itemNotaFiscal.impostos.st.baseCalculoSubstituicaoTributaria;
                state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal += state.venda.itens[index].itemNotaFiscal.impostos.st.valorSubstituicaoTributaria;

                state.venda.itens[index].itemNotaFiscal.impostos.ipi.baseCalculoIpi = retornoCalculoTributacoes.ipi.baseCalculo;
                state.venda.itens[index].itemNotaFiscal.impostos.ipi.valorIpi = retornoCalculoTributacoes.ipi.valor;

                state.venda.notaFiscal.totalImpostos.baseCalculoIpiTotal += state.venda.itens[index].itemNotaFiscal.impostos.ipi.baseCalculoIpi;
                state.venda.notaFiscal.totalImpostos.valorIpiTotal += state.venda.itens[index].itemNotaFiscal.impostos.ipi.valorIpi;

                state.venda.itens[index].itemNotaFiscal.impostos.pis.baseCalculoPis = retornoCalculoTributacoes.pis.baseCalculo;
                state.venda.itens[index].itemNotaFiscal.impostos.pis.valorPis = retornoCalculoTributacoes.pis.valor;

                state.venda.notaFiscal.totalImpostos.baseCalculoPisTotal += state.venda.itens[index].itemNotaFiscal.impostos.pis.baseCalculoPis;
                state.venda.notaFiscal.totalImpostos.valorPisTotal += state.venda.itens[index].itemNotaFiscal.impostos.pis.valorPis;

                state.venda.itens[index].itemNotaFiscal.impostos.cofins.baseCalculoCofins = retornoCalculoTributacoes.cofins.baseCalculo;
                state.venda.itens[index].itemNotaFiscal.impostos.cofins.valorCofins = retornoCalculoTributacoes.cofins.valor;

                state.venda.notaFiscal.totalImpostos.baseCalculoCofinsTotal += state.venda.itens[index].itemNotaFiscal.impostos.cofins.baseCalculoCofins;
                state.venda.notaFiscal.totalImpostos.valorCofinsTotal += state.venda.itens[index].itemNotaFiscal.impostos.cofins.valorCofins;

                state.venda.itens[index].itemNotaFiscal.impostos.valorTotalTributos = retornoCalculoTributacoes.valorTotalTributos;
                state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal += state.venda.itens[index].itemNotaFiscal.impostos.valorTotalTributos;

                state.valorTotalImpostos = state.venda.notaFiscal.totalImpostos.valorIcmsTotal + state.venda.notaFiscal.totalImpostos.valorIcmsSubstituicaoTotal + state.venda.notaFiscal.totalImpostos.valorPisTotal + state.venda.notaFiscal.totalImpostos.valorCofinsTotal;
              }
            }
          }

          state.venda.notaFiscal.totalNotaFiscal = state.venda.notaFiscal.totalProdutos;
          const incidenciaTotal = state.incidenciasCalculo.filter((c) => c.incidencia === 'TotalNota');
          incidenciaTotal.forEach((itemIncidencia) => {
            if (itemIncidencia.identificador === 'IPI' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal += state.venda.notaFiscal.totalImpostos.valorIpiTotal;
            }
            if (itemIncidencia.identificador === 'OutrasDespesas' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal += state.venda.notaFiscal.totalOutrasDespesas;
            }
            if (itemIncidencia.identificador === 'Desconto' && itemIncidencia.valor) {
              state.venda.notaFiscal.totalNotaFiscal -= state.venda.notaFiscal.totalDesconto;
            }
          });

          state.venda.notaFiscal.percentualDesconto = UtilitarioMatematico.calcularPorcentagem(state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalDesconto);
          state.venda.totalServicos = 0;
        }, 600);
      }
    }

    async function SalvarItem() {
      await obterDadosFiscaisProduto();
      state.item = servicoVendas.calcularTotalItem(state.itemSelecionado);
      state.item.itemNotaFiscal.codigoUnidade = state.item.itemNotaFiscal.codigoUnidadePrincipal;
      state.item.itemNotaFiscal.movimentarEstoque = state.tipoOperacao.movimentarEstoque;
      const estoque = {} as INotaFiscalItemEstoque;
      estoque.codigoEmpresa = dadosEmpresa.value.codigoEmpresa;
      estoque.codigoEstoque = props.dadosPadraoFrenteCaixa.codigoEstoque;
      estoque.codigoEstoqueItem = state.estoqueItem;
      estoque.quantidade = state.item.itemNotaFiscal.quantidade;
      state.item.itemNotaFiscal.estoques.push(estoque);
      state.venda.itens.push(state.item);
      state.itemSelecionado = instanciaNovoItem();
      await atualizarValoresTotais();
      await nextTick();
      if (refSelecionarProduto.value) {
        refSelecionarProduto.value.focus();
      }
    }

    async function atualizarDescontoGeral() {
      for (let index = 0; index < state.venda.itens.length; index += 1) {
        if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
          const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));

          if (state.venda.notaFiscal.totalDesconto > 0) {
            state.venda.itens[index].itemNotaFiscal.valorDesconto = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, state.venda.notaFiscal.totalDesconto);
          } else {
            state.venda.itens[index].itemNotaFiscal.valorDesconto = 0;
          }
        }
      }
      atualizarValoresTotais();
    }

    function removerTaxasPagamento(acrescimo: number, outrasTaxas: number) {
      state.venda.notaFiscal.totalOutrasDespesas -= outrasTaxas;
      state.venda.itens.forEach((i, index) => {
        const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));
        if (acrescimo > 0) {
          const acrescimoItem = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, acrescimo);
          state.venda.itens[index].itemNotaFiscal.precoUnitario -= (acrescimoItem / state.venda.itens[index].itemNotaFiscal.quantidade);
        }
      });
      atualizarValoresTotais();
    }

    async function recuperarCacheRegistro() {
      if (UtilitarioGeral.valorValido(state.cacheRegistro.dados)) {
        telaBase.carregando = true;
        const vendaCache = JSON.parse(state.cacheRegistro.dados);
        if (UtilitarioGeral.objetoValido(vendaCache)) {
          state.venda = vendaCache;
          state.cacheDisponivel = false;
          state.cacheRegistro = {} as ISalvamentoAutomatico;
          state.cacheRegistro.codigo = 0;
          apresentarMensagemSucesso('Informações recuperadas com sucesso!');
        }
        telaBase.carregando = false;
      }
    }

    function validarCampos() {
      if (!UtilitarioGeral.validaCodigo(state.venda.codigoVendedor)) {
        apresentarMensagemAlerta('O vendedor deve ser informado!');
        return false;
      }

      if (!UtilitarioGeral.validaCodigo(state.venda.codigoCliente)) {
        apresentarMensagemAlerta('O cliente deve ser informado!');
        return false;
      }

      if (!UtilitarioGeral.validaCodigo(state.venda.codigoFormaPagamento)) {
        apresentarMensagemAlerta('A forma de pagamento deve ser informado!');
        return false;
      }

      if (state.statusBloqueioCliente && !state.liberacaoBloqueioCliente) {
        requisicaoAutorizacaoBase.permissao = 'AUT_VENDA_BLOQUEIO_MOV';
        requisicaoAutorizacaoBase.descricao = 'Autorização para Cliente com bloqueio de movimentação!';
        requisicaoAutorizacaoBase.exibirRequisicao = true;
        return false;
      }

      return true;
    }

    async function imprimir() {
      const retornoRelatorio = await servicoVendas.imprimirTermico(state.venda.codigo);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.abriuPDF = true;
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function salvar() {
      state.venda.codigoVendedor = await servicoColaborador.obterPorUsuario(props.aberturaCaixa.codigoOperador);
      if (!validarCampos()) return;

      const retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      state.venda.notaFiscal.detalhesPagamento.forEach((d) => {
        if (!UtilitarioGeral.validaCodigo(d.codigoPlanoContaCategoria) && retorno.status !== EStatusRetornoRequisicao.Erro) {
          retorno.status = EStatusRetornoRequisicao.Erro;
          apresentarMensagemAlerta('Todos os detalhes de pagamento devem ter categoria definida!');
        }
      });
      if (retorno.status === EStatusRetornoRequisicao.Erro) {
        return;
      }

      const retornoValidacaoPagamento = await servicoVendas.validarFormaPagamento(state.venda.notaFiscal, state.venda.formaPagamento);
      if (retornoValidacaoPagamento.status !== EStatusRetornoRequisicao.Sucesso) {
        apresentarRetornoRequisicao(retornoValidacaoPagamento);
        return;
      }

      state.venda.notaFiscal.incidenciasCalculo = state.incidenciasCalculo;
      state.venda.notaFiscal.detalhesPagamento.forEach((d, indexD) => {
        state.venda.notaFiscal.detalhesPagamento[indexD].codigoNotaFiscal = state.venda.notaFiscal.codigo;
      });

      if (UtilitarioGeral.validaLista(state.venda.itens)) {
        const indexSemCodigos: number[] = [];
        for (let index = 0; index < state.venda.itens.length; index += 1) {
          if (!UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
            indexSemCodigos.push(index);
          }
        }
        indexSemCodigos.forEach((index) => {
          state.venda.itens.splice(index, 1);
        });

        state.venda.notaFiscal.naturezaOperacao = UtilitarioGeral.limitarQuantidadeMaximaCaracteres(state.tipoOperacao.descricao, 60);
      }

      if (state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal > 0) {
        if (UtilitarioGeral.objetoValido(state.venda.notaFiscal.dadosAdicionais)) {
          if (!state.venda.notaFiscal.dadosAdicionais.includes('VALOR APROX. TRIBUTOS R$')) {
            const percentual = UtilitarioMatematico.valorDecimal2Casas((state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal / state.venda.notaFiscal.totalNotaFiscal) * 100);
            state.venda.notaFiscal.dadosAdicionais += `VALOR APROX. TRIBUTOS R$ ${UtilitarioMascara.mascararValor(state.venda.notaFiscal.totalImpostos.valorAproximadoTributosTotal)} (${percentual} %) Fonte: IBPT`;
          }
        }
      }

      const retornoFinalizar = await servicoVendas.incluirFrenteCaixa(state.venda);

      if (retornoFinalizar.status === 1) {
        if (retornoFinalizar.codigoRegistro > 0) {
          state.venda.codigo = retornoFinalizar.codigoRegistro;
          await imprimir();
        }
        apresentarMensagemSucesso('Venda Realizada com Sucesso');
        await novaVenda();
      } else {
        apresentarMensagemAlerta(retornoFinalizar.mensagem);
      }
    }

    async function finalizar() {
      state.exibirFechamentoVenda = true;
    }

    async function adicionarTaxasPagamento(acrescimo: number, outrasTaxas: number) {
      state.venda.notaFiscal.totalOutrasDespesas += outrasTaxas;
      if (acrescimo > 0) {
        state.venda.itens.forEach((i, index) => {
          state.venda.itens[index].itemNotaFiscal.precoUnitario = state.venda.itens[index].precoTabela;
          const subTotalProduto = servicoCalculosComerciais.formatarValor2CasasDecimais((state.venda.itens[index].itemNotaFiscal.quantidade * state.venda.itens[index].itemNotaFiscal.precoUnitario));
          const acrescimoItem = servicoCalculosComerciais.calculaValorRateio(subTotalProduto, state.venda.notaFiscal.totalProdutos, acrescimo);
          state.venda.itens[index].itemNotaFiscal.precoUnitario += (acrescimoItem / state.venda.itens[index].itemNotaFiscal.quantidade);
        });
        atualizarValoresTotais();
      }
      const valorTotalPagamento = state.venda.notaFiscal.detalhesPagamento.reduce((total, pagamento) => total + pagamento.valorPagamento, 0);
      if (valorTotalPagamento < state.venda.notaFiscal.totalNotaFiscal) {
        apresentarMensagemAlerta('O valor total dos pagamentos é menor que o total da venda. Por favor, ajuste os valores para prosseguir.');
        return;
      }
      await salvar();
    }

    watch(async () => modalBase.computedVisivel, async () => {
      state.telaMobile = UtilitarioDispositivo.larguraTelaMobile();
      limparTela();
      if (modalBase.computedVisivel) {
        telaBase.carregando = true;
        await preencherEmpresasDisponiveis();
        telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
        const autorizacaoBloqueioMov = await servicoSistema.obterPermissoesAutorizacoesUsuario('AUT_VENDA_BLOQUEIO_MOV');
        state.liberacaoBloqueioCliente = servicoSistema.verificaAutorizacao(state.venda.codigoEmpresa, 'AUT_VENDA_BLOQUEIO_MOV', autorizacaoBloqueioMov);
        const autorizacaoBloqueio = await servicoSistema.obterPermissoesAutorizacoesUsuario('AUT_ALTERACAO_COMISSAO');
        state.editarComissao = servicoSistema.verificaAutorizacao(state.venda.codigoEmpresa, 'AUT_ALTERACAO_COMISSAO', autorizacaoBloqueio);
        state.tipoInfoBloqueioCliente = state.liberacaoBloqueioCliente ? 'info' : 'warning';
        telaBase.carregando = false;
        await preencherTipoOperacao();
        await atualizarInformacoesPessoa(false);
        state.caixa = await servicoCaixa.obter(computedAberturaCaixa.value.codigoCaixa, dadosEmpresa.value.codigoEmpresa);
        clearTimeout(debounceRenderizar);
        debounceRenderizar = setTimeout(async () => {
          focusElemento(1);
        }, 150);
        await nextTick(); // garante que o filho terminou de montar
        if (refSelecionarProduto.value) {
          refSelecionarProduto.value.focus();
        }
      }
    });

    function obtemDescricaoIncidencia(identificador: string): string {
      if (identificador === 'OutrasDespesas') {
        return 'Outras Despesas';
      }

      return identificador;
    }

    async function verificaFocoFormaPagamento() {
      if (state.venda.codigo === 0) {
        await salvar();
      }
    }

    async function fechar() {
      if (computedAberturaCaixa.value.status === EStatusAberturaCaixa.Fechada) {
        state.exibirAberturaCaixa = true;
      } else {
        state.exibirFechamentoCaixa = true;
      }
    }

    async function atualizarCaixa() {
      const aberturaCaixa = await servicoControleCaixas.obterAberturaCaixa(computedAberturaCaixa.value.codigo, dadosEmpresa.value.codigoEmpresa);
      computedAberturaCaixa.value = aberturaCaixa;
      limparTela();
      await preencherTipoOperacao();
      await atualizarInformacoesPessoa(false);
      state.caixa = await servicoCaixa.obter(computedAberturaCaixa.value.codigoCaixa, dadosEmpresa.value.codigoEmpresa);
    }

    function abrirCliente() {
      state.exibirSelecionarCliente = true;
    }

    async function excluirItem(index: number) {
      if (!UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
        state.venda.itens.splice(index, 1);
        return;
      }
      Modal.confirm({
        title: 'Você confirma a exclusão do item?',
        content: `${state.venda.itens[index].itemNotaFiscal.descricao}`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: 'ok',
        onOk: async () => {
          state.venda.itens.splice(index, 1);
          await atualizarValoresTotais();
        },
      });
    }

    async function adicionarDesconto(index: number) {
      if (UtilitarioGeral.validaCodigo(state.venda.itens[index].itemNotaFiscal.codigoProdutoDefinicao)) {
        state.produtoSelecionado = state.venda.itens[index];
        state.exibirDesconto = true;
        state.inserindoDesconto = true;
      }
    }

    async function concluirDesconto() {
      const index = state.venda.itens.findIndex((c) => c.itemNotaFiscal.codigoProdutoDefinicao === state.produtoSelecionado.itemNotaFiscal.codigoProdutoDefinicao);
      state.venda.itens[index].itemNotaFiscal.valorDesconto = state.produtoSelecionado.itemNotaFiscal.valorDesconto;
      state.venda.itens[index].itemNotaFiscal.precoUnitario = state.produtoSelecionado.itemNotaFiscal.precoUnitario;
      await atualizarValoresTotais();
    }

    function confirmarSelecao() {
      adicionarDesconto(state.indexSelecionado);
      state.navegandoLista = false;
    }

    const handleKeydown = (event: KeyboardEvent): void => {
      if (event.shiftKey) {
        switch (event.key.toLowerCase()) {
          case 'n':
            event.preventDefault();
            realizarNovaVenda();
            break;
          case 'f':
            event.preventDefault();
            finalizar();
            break;
          case 'p':
            event.preventDefault();
            abrirCliente();
            break;
          case 'e':
            event.preventDefault();
            fechar();
            break;
          case 'i':
            event.preventDefault();
            event.stopImmediatePropagation(); // impede que outro componente (como o selecionar-produto) capture o evento
            state.navegandoLista = !state.navegandoLista;

            if (state.navegandoLista) {
              state.indexSelecionado = 0;
              nextTick(() => {
                const el = listaContainer.value as HTMLElement | null;
                if (el) {
                  el.setAttribute('tabindex', '0'); // garante que pode receber foco
                  el.focus();
                }
              });
            } else {
              // caso desative o modo navegação, remove o tabindex pra não interferir depois
              const el = listaContainer.value as HTMLElement | null;
              if (el) el.removeAttribute('tabindex');
            }
            break;
          case 'u':
            event.preventDefault();
            adicionarDesconto(state.venda.itens.length - 1);
            break;
          default:
            break;
        }
      }

      // ignora se não estiver em modo navegação
      if (!state.navegandoLista) return;

      // impede que inputs, selects etc. capturem as setas
      const tag = (event.target as HTMLElement)?.tagName;
      const ignorar = ['INPUT', 'TEXTAREA', 'SELECT'];
      if (ignorar.includes(tag)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }

      // eslint-disable-next-line default-case
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          if (state.indexSelecionado < state.venda.itens.length - 1) {
            state.indexSelecionado += 1;
          }
          break;
        case 'ArrowUp':
          event.preventDefault();
          if (state.indexSelecionado > 0) {
            state.indexSelecionado -= 1;
          }
          break;
        case 'Enter':
          event.preventDefault();
          confirmarSelecao();
          break;
        case 'Escape':
          event.preventDefault();
          state.navegandoLista = false;
          break;
      }
    };

    // ✅ Scroll automático do item selecionado
    watch(() => state.indexSelecionado, async (novo) => {
      await nextTick();
      const lista = listaContainer.value;
      const itens = lista?.querySelectorAll('.list-item');
      if (!lista || !itens || !itens[novo]) return;

      const item = itens[novo] as HTMLElement;
      const itemTop = item.offsetTop;
      const itemBottom = itemTop + item.offsetHeight;
      const scrollTop = lista.scrollTop;
      const viewBottom = scrollTop + lista.clientHeight;

      if (itemTop < scrollTop) lista.scrollTop = itemTop;
      else if (itemBottom > viewBottom) lista.scrollTop = itemBottom - lista.clientHeight;
    });

    onMounted(async () => {
      atualizarDataHora();
      intervalo = setInterval(atualizarDataHora, 1000); // atualiza a cada segundo
      await nextTick(); // garante que o filho terminou de montar
      if (refSelecionarProduto.value) {
        refSelecionarProduto.value.focus();
      }
      document.addEventListener('fullscreenchange', handleFullScreenChange);
      window.addEventListener('keydown', handleKeydown);
    });

    onUnmounted(() => {
      clearInterval(intervalo);
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      window.removeEventListener('keydown', handleKeydown);
    });

    async function focusCampoProduto() {
      state.abriuPDF = false;
      await nextTick();
      if (refSelecionarProduto.value?.focus) {
        refSelecionarProduto.value.focus();
      }
    }

    return {
      props,
      state,
      telaBase,
      modalBase,
      requisicaoAutorizacaoBase,
      etapa,
      ETipoValorMovimentacao,
      ETipoMovimentoComercial,
      ETipoRelacaoPessoa,
      servicoVendas,
      UtilitarioGeral,
      UtilitarioMascara,
      storeSistema,
      recuperarCacheRegistro,
      apresentarRetornoRequisicao,
      atualizarDescontoGeral,
      atualizarValoresTotais,
      obterFormaPagamento,
      salvar,
      imprimir,
      obtemDescricaoIncidencia,
      focusElemento,
      proximoElemento,
      elementoAnterior,
      verificaFocoFormaPagamento,
      atualizarInformacoesPessoa,
      adicionarTaxasPagamento,
      removerTaxasPagamento,
      permissaoServico,
      preencherTipoOperacao,
      ECustomRenderRow,
      EStatusNotaFiscal,
      fechar,
      dadosEmpresa,
      obterDadosFiscaisProduto,
      SalvarItem,
      dataAtual,
      horaAtual,
      finalizar,
      novaVenda,
      abrirCliente,
      computedAberturaCaixa,
      atualizarCaixa,
      excluirItem,
      realizarNovaVenda,
      refSelecionarProduto,
      focusCampoProduto,
      concluirDesconto,
      adicionarDesconto,
      listaContainer,
      confirmarSelecao,
      handleKeydown,
    };
  },
});
